import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "SUM_OF_ALL_BOX_AMOUNT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setSumOfAllBoxAmount: (state, action) => {
            state.sumOfAllBoxAmount = action.payload
        },

    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.LOADING, message: "" },
        sumOfAllBoxAmount: [],
    }
})

export const { setLoadingState, setSumOfAllBoxAmount } = actions; 